export default [
  {
    meta: {
      icon: 'iconfont iconjichuxinxiguanli',
      title: '资讯内容',
      uri: '/newRetail/realTimeInfo',
    },
    subMenus: [
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '品牌资讯',
          uri: '/newRetail/realTimeInfo/brandinformation',
        },
        component: () => import('./brand-information.vue'),
        path: '/newRetail/realTimeInfo/brandinformation',
      },
      {
        meta: {
          icon: 'iconfont iconxiaoshoushujuguanli',
          title: '经销商资讯',
          uri: '/newRetail/realTimeInfo/dealerinformation',
        },
        component: () => import('./dealer-information.vue'),
        path: '/newRetail/realTimeInfo/dealerinformation',
      },
    ],
  }
]
